// extracted by mini-css-extract-plugin
export default {"button":"XZyB3zy09oNiJPYXzMaR","cal":"V8lrMEK6XXJUFDwsrtSs"};